import * as React from "react";
import { SVGProps, memo } from "react";

const SvgIncomplete = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.481-9.266a.75.75 0 1 0-1.06-1.06l-3.166 3.165L7.58 9.164a.75.75 0 1 0-1.061 1.06l2.029 2.03a1 1 0 0 0 1.414 0l3.52-3.52Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgIncomplete);

export default Memo;
